<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <mask
        id="rf-tune-a"
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
      >
        <path fill="#d9d9d9" stroke="none" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#rf-tune-a)">
        <path
          fill="inherit"
          stroke="none"
          d="M11.5 20.5v-5h1v2h8v1h-8v2zm-8-2v-1h5v1zm4-4v-2h-4v-1h4v-2h1v5zm4-2v-1h9v1zm4-4v-5h1v2h4v1h-4v2zm-12-2v-1h9v1z"
        />
      </g>
    </svg>
  </span>
</template>
